import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { GoodType } from '../../bmcore-goods-block/bmcore-goods-block.component'

@Component({
  selector: 'bmcore-goods-page',
  templateUrl: 'bmcore-goods-page.component.html',
  styleUrls: ['bmcore-goods-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGoodsPageComponent implements OnInit {
  lg: LgType
  goods: Array<GoodType> = [
    {
      id: 1,
      title: 'Drum Kit dolor sit amet, consectetur adipisicing elit. Consequuntur, corporis!',
      src: 'drum-kit-sub.jpg',
      price: 1000
    },
    {
      id: 2,
      title: 'Piano sit amet, consectetur adipisicing elit. Molestias nobis porro quas quos, soluta tempora.',
      src: 'piano-stub.jpg',
      price: 1500
    },
    { id: 3, title: 'ProducerName Vocal Samples Volume 1', src: 'vocal-stub.jpg', price: 500 },
    { id: 4, title: 'Sample Pack', src: 'violin-stub.jpg', price: 1500 },
    {
      id: 5,
      title: 'Guitar sit amet, consectetur adipisicing elit. Molestias nobis porro quas quos, soluta tempora.',
      src: 'guitar-stub.jpg',
      price: 2300
    },
    { id: 6, title: 'ProducerName Trumpet Volume 1', src: 'trumpet-stub.jpg', price: 1900 }
  ]

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getGoods()
  }

  getGoods() {
    return this.goods
  }
}
